import {
  clearLocalStorage,
  handleSegment,
  onError,
  redirectOnSuccess,
  SetAuthState,
} from '.'
import { HubEventCallback, initHubAuthListen } from '../../util/amplify-hub'
import {
  handleThriveUserId,
  getCachedUserData,
} from '../../util/thrive-user-data'
import { AppErrorDispatchType } from '../AppError'
import { trackApi as segmentTrackApi } from '../../api/segment'
import { SegmentPage, SegmentTrack } from '../../enums/segment'
import { AUTH_STATE } from '../../enums/auth-state'
import { segmentTrack } from '../../api/segment/track/track'

const onSignInFailure: HubEventCallback = (hubData): void => {
  segmentTrackApi(SegmentTrack.signIn, false, { errorCode: hubData.code })
}

const onSignUpFailure: HubEventCallback = (hubData): void => {
  segmentTrackApi(SegmentTrack.signUp, false, { errorCode: hubData.code })
}

const onForgotPassword: HubEventCallback = (): void => {
  segmentTrackApi(SegmentTrack.resetPassword, true)
}

const onForgotPasswordFailure: HubEventCallback = (hubData): void => {
  segmentTrackApi(SegmentTrack.resetPassword, false, {
    errorCode: hubData.code,
  })
}

const listenHubEvents = (
  setAuthState: SetAuthState,
  appErrorDispatch: AppErrorDispatchType
): void => {
  const onSignIn: HubEventCallback = async (hubData) => {
    try {
      await handleThriveUserId(hubData.attributes.email)
      handleSegment(getCachedUserData())
      redirectOnSuccess(setAuthState)
    } catch (e) {
      onError(e, setAuthState, appErrorDispatch)
    }
  }

  const onSignOut = (): void => {
    clearLocalStorage()
    segmentTrack(SegmentTrack.signOut, {
      page_name: SegmentPage.app,
      forced: true,
    })
    setAuthState(AUTH_STATE.UNAUTHD)
  }

  initHubAuthListen({
    onSignIn,
    onSignOut,
    onSignInFailure,
    onSignUpFailure,
    onForgotPassword,
    onForgotPasswordFailure,
  })
}

export { listenHubEvents }
